
import Vue from 'vue';
import { Toolbar, Link, Image, HtmlEditor, PasteCleanup } from '@syncfusion/ej2-vue-richtexteditor';
export default Vue.extend({
  name: 'RichTextEditor',
  props: {
    value: {
      type: String,
      default: '<p></p>',
    },

    colour: {
      type: String,
      default: 'dark',
    },
    variant: {
      type: String,
      default: 'full',
    },
  },
  data: function () {
    return {
      firstFocus: true,
      v: '<p></p>',
      simpleSettings: {
        items: ['Bold', 'Italic', 'Underline', '|', 'Formats', 'OrderedList', 'UnorderedList'],
      },
      pasteCleanUpSettings: {
        keepFormat: false,
        deniedAttrs: ['class', 'title', 'id'],
        deniedTags: ['div', 'script', 'span'],
        allowedStyleProps: [],
      },
      fullSettings: {
        items: [
          'Bold',
          'Italic',
          'Underline',
          '|',
          'Formats',
          'Alignments',
          'OrderedList',
          'UnorderedList',
          'BackgroundColor',
          '|',
          'CreateLink',
          'Image',
          '|',
          'SourceCode',
          '|',
          'Undo',
          'Redo',
        ],
      },
    };
  },
  beforeDestroy() {
    const editor = this.$refs?.editor?.ej2Instance;
    
    if (!editor) {
      return;
    }
    
    try {
      // Clear the content area to prevent any pending DOM operations
      if (editor.contentModule) {
        const editPanel = editor.contentModule.getEditPanel();
        if (editPanel) {
          editPanel.innerHTML = '';
        }
      }
      
      // Destroy QuickToolbar modules to prevent accessing undefined properties
      if (editor.quickToolbarModule) {
        const linkQTBar = editor.quickToolbarModule.linkQTBar;
        const imageQTBar = editor.quickToolbarModule.imageQTBar;
        const inlineQTBar = editor.quickToolbarModule.inlineQTBar;
        
        if (linkQTBar && typeof linkQTBar.destroy === 'function') {
          try {
            linkQTBar.destroy();
          } catch (e) {
            // Silently fail to prevent errors during component destruction
          }
        }
        
        if (imageQTBar && typeof imageQTBar.destroy === 'function') {
          try {
            imageQTBar.destroy();
          } catch (e) {
            // Silently fail to prevent errors during component destruction
          }
        }
        
        if (inlineQTBar && typeof inlineQTBar.destroy === 'function') {
          try {
            inlineQTBar.destroy();
          } catch (e) {
            // Silently fail to prevent errors during component destruction
          }
        }
      }
      
      // Destroy tooltip module
      if (editor.toolbarModule && editor.toolbarModule.toolbarRenderer) {
        const tooltip = editor.toolbarModule.toolbarRenderer.tooltip;
        if (tooltip && typeof tooltip.destroy === 'function') {
          try {
            tooltip.destroy();
          } catch (e) {
            // Silently fail to prevent errors during component destruction
          }
        }
      }
      
      // Destroy the main editor instance
      if (typeof editor.destroy === 'function') {
        editor.destroy();
      }
    } catch (e) {
      // Silently catch any errors during cleanup to prevent cascading errors
      console.error('Error during RichTextEditor cleanup:', e);
    }
  },
  computed: {
    editorColour() {
      if (this.colour === 'dark') {
        return 'rteditor';
      }
      return '';
    },

    editorVariant() {
      if (this.variant === 'full') {
        return this.fullSettings;
      }
      return this.simpleSettings;
    },
  },
  methods: {
    focusTextEditor(e) {
      const editor = this.$refs.editor;

      if (editor && this.firstFocus) {
        editor.focusIn();
        this.firstFocus = false;
      }
    },
  },
  provide: {
    richtexteditor: [Toolbar, Link, Image, HtmlEditor, PasteCleanup],
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.v = newVal;
      },
    },
    v(newVal) {
      this.$emit('input', newVal);
    },
  },
});
